<script setup>
import { swalError } from '@/helper';
import { create_subscription } from '@/services/subscriptions';
import { onMounted, ref } from 'vue';

const isLoading = ref(true)
const packageSub = ref({})
const features = ref([])
const temp_feature  = ref('')
const number_of_trait = ref()
const duration = ref()
const description = ref()
function addFeature(){
  features.value.push(temp_feature.value)
  temp_feature.value = ''
}

function removeFeature(i){
  features.value.splice(i, 1)
}

async function submit(){
  let params = {
    ...packageSub.value,
    subscription_meta_attributes: [
      {
        key: 'features',
        value: JSON.stringify(features.value)
      },
      {
        key: 'number_of_trait',
        value: number_of_trait.value
      },
      {
        key: 'duration',
        value: duration.value
      },
      {
        key: 'description',
        value: description.value
      },
    ]
  }
  let response = await create_subscription(params)
  if (response.error){
    swalError(response.result.message)
    return
  }
  Swal.fire({
    title: 'Submitted',
    text: 'Package has been submitted',
    icon: 'success'
  })
}

</script>

<template>
  <Breadcrumbs main="Add Subscription Package"/>
  
  <div class="container-fluid">
    <div class="row">
      <!-- Item List -->
      <template v-if="!isLoading">
        <loadingCard />
      </template>
      <template v-else>
        <div class="card">
          <div class="card-body">
            <!-- Package Name -->
            <div class="row">
              <!-- Package Name -->
              <div class="col-8">
                <div class="mb-3">
                  <label class="form-label" for="name">Package Name</label>
                  <!-- v-bind:class="formSubmitted ? nameError ? 'is-invalid' : 'is-valid' : ''"  -->
                  <input class="form-control" id="name" type="text"
                    placeholder="Sample Package"
                    required
                    v-model="packageSub.title"
                  >
                  <div class="form-text">
                    Package name to be displayed to client
                  </div>
                  <!-- <div class="invalid-feedback" v-if="errors.name">{{ errors.name }}</div>
                  <div class="valid-feedback" v-else>Looks good!</div> -->
                </div>
              </div>
              <!-- Price -->
              <div class="col-4">
                <div class="mb-3">
                  <label class="form-label" for="price">Price</label>
                  <div class="input-group mb-3">
                    <span class="input-group-text">RM</span>
                    <input type="number" 
                      class="form-control" 
                      placeholder="0.00"
                      v-model="packageSub.price"
                    >
                  </div>
                </div>
              </div>
            </div>
            
            <!-- Package Description -->
            <div class="row">
              <!-- Duration -->
              <div class="col-6">
                <div class="mb-3">
                  <label class="form-label" for="duration">Package Description</label>
                  <textarea class="form-control" id="duration"
                    required
                    v-model="description"
                  ></textarea>
                  <!-- <div class="invalid-feedback" v-if="errors.name">{{ errors.name }}</div>
                  <div class="valid-feedback" v-else>Looks good!</div> -->
                </div>
              </div>
              <!-- Trait Count -->
              <div class="col-6">
                <div class="mb-3">
                  <label class="form-label" for="trait_number">Number of Trait</label>
                  <input class="form-control" id="trait_number" 
                    type="number"
                    placeholder="2"
                    required
                    v-model="number_of_trait"
                  >
                  <!-- <div class="invalid-feedback" v-if="errors.name">{{ errors.name }}</div>
                  <div class="valid-feedback" v-else>Looks good!</div> -->
                </div>
              </div>
            </div>

            <!-- Duration & Number of Trait -->
            <div class="row">
              <!-- Duration -->
              <div class="col-6">
                <div class="mb-3">
                  <label class="form-label" for="duration">Duration (days)</label>
                  <input class="form-control" id="duration" 
                    type="number"
                    placeholder="120"
                    required
                    v-model="duration"
                  >
                </div>
              </div>
            </div>

            <!-- Feature List -->
            <div class="row mt-4">
              <div class="col-12" v-auto-animate>
                <div>
                  <h6 class="mb-0">Feature</h6>
                </div>
                <form @submit.prevent="addFeature()" class="row mt-2">
                  <div class="col-6">
                    <input class="form-control" 
                      type="text" 
                      placeholder="Free consultation" required
                      v-model="temp_feature"
                    >
                  </div>
                  <div class="col-2">
                    <button type="submit" class="btn-rounded-icon p-0 btn btn-success"
                    >
                      <vue-feather type="plus"></vue-feather>
                    </button>
                  </div>
                </form>
                <!-- items -->
                <div v-for="(feature, index) in features" class="row mt-2" v-auto-animate>
                  <div class="col-6">
                    <input class="form-control" 
                      type="text" 
                      placeholder="Feature Description" required
                      :value="feature"
                    >
                  </div>
                  <div class="col-2">
                    <button class="btn-rounded-icon p-0 btn btn-danger"
                      @click="removeFeature(index)"
                    >
                      <vue-feather type="x"></vue-feather>
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div class=" d-flex justify-content-end mt-2">
              <button class="btn btn-light-success"
                @click="submit()"
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<style scoped>
label.form-label{
  font-weight: 600;
}
</style>